import { UAParser } from 'ua-parser-js';

/** 移动端 / 平板浏览器（含 iOS Safari、Android Chrome） */
export function isMobileBrowser(): boolean {
    if (typeof navigator === 'undefined') {
        return false;
    }
    const deviceType = new UAParser(navigator.userAgent).getDevice().type;
    if (deviceType === 'mobile' || deviceType === 'tablet') {
        return true;
    }
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
